/**
 * For when context providers don't reach far enough...
 */

export enum GlobalFunction {
  getExploreContext,
  getToasterContext,
}

export function globalFunction(name: GlobalFunction) {
  return GLOBAL_FUNCTIONS[name];
}

const GLOBAL_FUNCTIONS: Record<GlobalFunction, Function | undefined> = {
  [GlobalFunction.getExploreContext]: undefined,
  [GlobalFunction.getToasterContext]: undefined,
};

export function registerGlobalFunction<T extends Function>(
  name: GlobalFunction,
  func: T
) {
  GLOBAL_FUNCTIONS[name] = func;
}

export function unregisterGlobalFunction(name: GlobalFunction) {
  GLOBAL_FUNCTIONS[name] = undefined;
}
